import React from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import {
  Grid, PageHeader, Table, Button, Glyphicon, Modal,
  FormGroup, ControlLabel, FormControl
} from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
// import {Table, Column, Cell} from "fixed-data-table-2"

import { Map } from "immutable"
import bcrypt from "bcryptjs"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"
import { ButtonAdd, getRecords } from "./Common"

class PasswordModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    updatePassword: PropTypes.func,
    username: PropTypes.string,
    password: PropTypes.string,
  }

  state = {}

  handleChange = e => {
    const { name, value } = e.target
    this.setState({ [name] : value })
  }

  handleSubmit = e => {
    e.preventDefault()

    const { password_old, password_new, password_confirm } = this.state
    let errors = ""

    if (!bcrypt.compareSync(password_old, this.props.password))
      errors = (errors.length > 0 ? "\n" : "") + "Wrong Password!"
    if (!password_new)
      errors = (errors.length > 0 ? "\n" : "") + "New Password is required!"
    else {
      if (password_new !== password_confirm)
        errors = (errors.length > 0 ? "\n" : "") + "New Password not matched!"
      if (bcrypt.compareSync(password_new, this.props.password))
        errors = (errors.length > 0 ? "\n" : "") + "New Password is the same with old password!"
    }

    if (errors) {
      alert(errors)
      return
    }

    this.props.updatePassword(this.props.username, password_old, password_new, password_confirm)
    this.props.onHide()
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide} aria-labelledby="password-modal">
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.handleSubmit}>
            <FormGroup>
              <ControlLabel>Username</ControlLabel>
              <FormControl.Static>{this.props.username}</FormControl.Static>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Current Password</ControlLabel>
              <FormControl type="password" name="password_old" placeholder="Current Password" onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <ControlLabel>New Password</ControlLabel>
              <FormControl type="password" name="password_new" placeholder="New Password" onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Confirm Password</ControlLabel>
              <FormControl type="password" name="password_confirm" placeholder="Confirm Password" onChange={this.handleChange} />
            </FormGroup>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.handleSubmit}>Update</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

class Users extends React.Component {
  static propTypes = {
    users: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  state = {
    pmShow: false
  }

  handleDelete = e => {
    e.preventDefault()
    
    const { id } = e.target
    if (window.confirm("Are you sure you want to delete this user?")) {
      this.props.actions.deleteUser(id)
    }
  }

  showPasswordModal = e => {
    e.preventDefault()

    const username = e.target.id
    const password = this.props.users.getIn([username, "password"])
    
    this.setState({ pmShow: true, username, password })
  }

  closePasswordModal = e => {
    this.setState({ pmShow: false, username: null, password: null })
  }

  render() {
    return (
      <Grid>
        <PageHeader>
          Users
          {/* <Button className="pull-right" bsSize="small" onClick={() => this.props.actions.refreshUsers()}>
            <Glyphicon glyph="refresh" />
          </Button> */}
          <span className="pull-right"><ButtonAdd to="/user/new" /></span>
        </PageHeader>

        <Table responsive fill striped>
          <thead>
            <tr>
              <th className="text-center">Username</th>
              <th className="text-center">Email</th>
              <th className="text-center">Last Login</th>
              <th className="text-center">Login IP</th>
              <th className="text-center">Access</th>
              <th className="text-center">Password</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            { getRecords(this.props.users).map(o => (
              <LinkContainer key={o.get("username")} to={`/user/${o.get("username")}`}>
                <tr>
                  <td>
                    {o.get("username")}
                    <Button className="pull-right" bsSize="xsmall" bsStyle="danger" id={o.get("username")}
                      onClick={this.handleDelete}>
                      <Glyphicon glyph="trash" id={o.get("username")} />
                    </Button> 
                  </td>
                  <td className="text-center">{o.get("email")}</td>
                  <td className="text-center">{o.get("loginTime") ? moment(o.get("loginTime")).format("LLL") : ""}</td>
                  <td className="text-center">{o.get("loginIp")}</td>
                  <td className="text-center">&nbsp;</td>
                  <td className="text-center">
                    <Button bsSize="xsmall" bsStyle="warning"
                      id={o.get("username")}
                      onClick={this.showPasswordModal}>
                      Change
                    </Button>
                  </td>
                  <td className="text-center">{o.get("status")}</td>
                </tr>
              </LinkContainer>
            )) }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="100">&nbsp;</td>
            </tr>
          </tfoot>
        </Table>

        <PasswordModal show={this.state.pmShow} onHide={this.closePasswordModal}
          updatePassword={this.props.actions.updatePassword}
          username={this.state.username} password={this.state.password} />
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  users: state.get("users") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users)



// WEBPACK FOOTER //
// ./src/components/Users.js